<template>
    <div class="maxbox">
        <div>
            <div class="top">
                <p>设置</p>
            </div>
            <div class="main">
                <button class="return" @click="goback"><img src="@/assets/images/left-arrow.png" alt=""></button>
                
                <div class="main-content">
                    <!-- 新增：SBS管理按钮 -->
                    <button class="sbs-management" @click="viewFCCoins">CYC管理</button>

                    <!-- 新增：查看收货地址按钮 -->
                    <button class="view-address" @click="viewShippingAddresses">查看收货地址</button>
                    <label for="recipientAddress">接收地址：</label>
                    <input type="text" id="recipientAddress" v-model="recipientAddress" placeholder="请输入接收地址" />
                    <label for="transferAmount">金额(USDT)：</label>
                    <input type="text" id="transferAmount" v-model="transferAmount" placeholder="请输入转账金额 (USDT)" />
                    <button id="transferFundsBtn" @click="transferFunds">转账</button>
                    <div id="referrals"></div>
                    <p id="totalReferrals"></p>
                    <button id="getContractBalanceBtn" @click="getContractBalance">查询USDT余额</button>

                    <!-- 新增：免费激活会员账户 -->
                    <label for="newUserAddress">新用户地址：</label>
                    <input type="text" id="newUserAddress" v-model="newUserAddress" placeholder="请输入新用户地址" />
                    <label for="referrerAddress">推荐人地址：</label>
                    <input type="text" id="referrerAddress" v-model="referrerAddress" placeholder="请输入推荐人地址" />
                    <!-- 移除原来的下拉选择框 -->
                    <!-- <label for="membershipType">会员类型：</label>
                    <select id="membershipType" v-model="membershipType">
                        <option value="v1">v1</option>
                        <option value="v2">v2</option>
                        <option value="v3">v3</option>
                    </select> -->
                    <!-- 新增：选择会员类型的按钮 -->
                    <button @click="showMembershipModal = true">选择会员类型 (当前: {{ membershipType }})</button>
                    <button @click="activateMembership">激活会员账户</button>

                    <!-- 新增：修改推荐关系 -->
                    <label for="userAddress">被改变推荐关系的用户地址：</label>
                    <input type="text" id="userAddress" v-model="userAddress" placeholder="请输入用户地址" />
                    <label for="newReferrerAddress">新推荐人地址：</label>
                    <input type="text" id="newReferrerAddress" v-model="newReferrerAddress" placeholder="请输入新推荐人地址" />
                    <button @click="modifyReferrer">修改推荐关系</button>

                    <!-- 新增：弹出框 -->
                    <div v-if="showMembershipModal" class="modal">
                        <div class="modal-content">
                            <span class="close" @click="showMembershipModal = false">&times;</span>
                            <h2>选择会员类型</h2>
                            <button @click="selectMembershipType('v1')">V1</button>
                            <button @click="selectMembershipType('v2')">V2</button>
                            <button @click="selectMembershipType('v3')">V3</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ethers } from 'ethers';
import { contractAddress, contractABI } from '@/js/contract.js';

export default {
    name: 'settings',
    data() {
        return {
            recipientAddress: '',
            transferAmount: '',
            newUserAddress: '', // 新增：新用户地址状态
            referrerAddress: '', // 新增：推荐人地址状态
            membershipType: 'v1', // 新增：会员类型
            userAddress: '', // 新增：被改变推荐关系的用户地址
            newReferrerAddress: '', // 新增：新推荐人地址
            showMembershipModal: false // 新增：控制弹出框显示状态
        };
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
        async connectWallet() {
            try {
                if (typeof window.ethereum !== 'undefined') {
                    this.provider = new ethers.providers.Web3Provider(window.ethereum);
                    await this.provider.send("eth_requestAccounts", []);
                    this.signer = this.provider.getSigner();
                    this.contract = new ethers.Contract(contractAddress, contractABI, this.signer);
                } else {
                    alert('未检测到以太坊钱包，请安装MetaMask。');
                }
            } catch (error) {
                console.error('连接钱包失败:', error);
                alert('连接钱包失败！');
            }
        },
        async transferFunds() {
            if (!this.recipientAddress || !this.transferAmount) {
                alert('请填写接收地址和转账金额。');
                return;
            }

            try {
                await this.connectWallet();
                const tx = await this.contract.withdraw(this.recipientAddress);
                await tx.wait();
                alert('转账成功！');
            } catch (error) {
                console.error('转账失败:', error);
                alert('转账失败！');
            }
        },
        async getContractBalance() {
            try {
                await this.connectWallet();
                const balance = await this.contract.getContractBalance();
                // 格式化余额为整数，精度为6
                const formattedBalance = ethers.utils.formatUnits(balance, 6);
                alert(`合约USDT余额：${parseFloat(formattedBalance).toFixed(0)} USDT`);
            } catch (error) {
                console.error('查询合约余额失败:', error);
                alert('查询合约余额失败！');
            }
        },
        async activateMembership() {
            if (!this.newUserAddress || !this.referrerAddress) {
                alert('请填写新用户地址和推荐人地址。');
                return;
            }

            try {
                await this.connectWallet();
                const isV2 = this.membershipType === 'v2';
                const isV3 = this.membershipType === 'v3';
                const tx = await this.contract.freeRegister(this.newUserAddress, this.referrerAddress, isV2, isV3);
                await tx.wait();
                alert('会员账户激活成功！');
            } catch (error) {
                console.error('会员账户激活失败:', error);
                alert(`会员账户激活失败！错误信息：${error.message}`);
            }
        },
        async modifyReferrer() {
            if (!this.userAddress || !this.newReferrerAddress) {
                alert('请填写用户地址和新推荐人地址。');
                return;
            }

            try {
                await this.connectWallet();
                const tx = await this.contract.modifyReferrer(this.userAddress, this.newReferrerAddress);
                await tx.wait();
                alert('推荐关系修改成功！');
            } catch (error) {
                console.error('推荐关系修改失败:', error);
                alert(`推荐关系修改失败！错误信息：${error.message}`);
            }
        },
        viewShippingAddresses() {
            this.$router.push({ path: '/delivery' });
        },
        viewFCCoins() {
            this.$router.push({ path: '/fc-coins' });
        },
        // 新增：选择会员类型方法
        selectMembershipType(type) {
            this.membershipType = type;
            this.showMembershipModal = false;
        }
    },
    mounted() {
        // 移除获取MATIC余额的逻辑
    }
}
</script>

<style scoped>
@import "@/assets/css/settings.css";
@import "@/assets/css/style.css";

.main {
    padding-top: 50px;
}

.view-address, .sbs-management {
    padding: 10px;
    border-radius: 4px;
    border: none;
    background-color: #28a745;
    color: white;
    cursor: pointer;
    margin-top: 10px;
}

.view-address:hover, .sbs-management:hover {
    background-color: #218838;
}

/* 弹出框样式 */
.modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.4);
}

.modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 280px;
    text-align: center;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}
</style>